import type { SyntaxNode } from 'web-tree-sitter';
import type { MemberAccessRule } from './types.js';
import { MEMBER_NAME_NODE_TYPES } from './types.js';

export function nodesMatch(a: SyntaxNode, b: SyntaxNode): boolean {
  return (
    a.startPosition.row === b.startPosition.row &&
    a.startPosition.column === b.startPosition.column &&
    a.text === b.text
  );
}

function fieldNodeMatches(node: SyntaxNode | null, candidate: SyntaxNode): boolean {
  return node != null && nodesMatch(node, candidate);
}

export function isReceiverNameNode(node: SyntaxNode): boolean {
  return (
    MEMBER_NAME_NODE_TYPES.has(node.type) ||
    node.type === 'this' ||
    node.type === 'self' ||
    node.type === 'super'
  );
}

export function objectNodeFromAccessNode(accessNode: SyntaxNode, rule: MemberAccessRule): SyntaxNode | null {
  const objectNode = accessNode.childForFieldName(rule.objectField);
  if (!objectNode || !isReceiverNameNode(objectNode)) return null;
  return objectNode;
}

export function isMemberAccessPropertyNameNode(nameNode: SyntaxNode, rules: readonly MemberAccessRule[]): boolean {
  const parent = nameNode.parent;
  if (!parent) return false;

  for (const rule of rules) {
    if (parent.type !== rule.parentType) continue;
    if (fieldNodeMatches(parent.childForFieldName(rule.propertyField), nameNode)) return true;
  }

  return false;
}

export function propertyNodeFromAccessNode(accessNode: SyntaxNode, rule: MemberAccessRule): SyntaxNode | null {
  const propertyNode = accessNode.childForFieldName(rule.propertyField);
  if (!propertyNode || !MEMBER_NAME_NODE_TYPES.has(propertyNode.type)) return null;
  return propertyNode;
}
